export const PAYMENT_FLOW_STORAGE_KEY = 'payment-flow-mashpoa';
export const LEGACY_PAYMENT_FORM_STORAGE_KEY = 'payment-form-mashpoa';
export const PAYMENT_FLOW_STEP_STORAGE_KEY = 'payment-flow-step';

export interface StoredPaymentFlow {
  version: 1;
  currentStep: 'passenger' | 'payment';
  acceptedTerms: boolean;
  seatIds: string[];
}
